module.exports = __webpack_public_path__ + "static/banner-9615fab5c63ff230390d8eab9ea6965b.png";